import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const http = axios.create({ baseURL: API, withCredentials: true });

export const fetchSite = () => http.get("/site").then((r) => r.data);
export const fetchBlog = () => http.get("/blog").then((r) => r.data);
export const fetchPost = (slug) => http.get(`/blog/${slug}`).then((r) => r.data);
export const postLead = (payload) => http.post("/leads", payload).then((r) => r.data);
export const postSurvey = (payload) => http.post("/survey", payload).then((r) => r.data);

// Admin (authenticated via cookies)
export const fetchStats = (days) => http.get("/admin/stats", { params: { days } }).then((r) => r.data);
export const pingIndexNow = () => http.post("/admin/indexnow").then((r) => r.data);
export const aiTranslate = (text, source_lang = "es") => http.post("/admin/ai/translate", { text, source_lang }).then((r) => r.data);
export const aiDraft = (payload) => http.post("/admin/ai/draft", payload).then((r) => r.data);
export const fetchChats = (limit = 30) => http.get("/admin/chats", { params: { limit } }).then((r) => r.data);
export const fetchSurveyStats = () => http.get("/admin/survey/stats").then((r) => r.data);
export const fetchSurveyList = (params) => http.get("/admin/survey", { params }).then((r) => r.data);
export const fetchSurveyDetail = (id) => http.get(`/admin/survey/${id}`).then((r) => r.data);
export const fetchSurveyProposals = () => http.get("/admin/survey/proposals").then((r) => r.data);
export const patchSurveyProposal = (payload) => http.patch("/admin/survey/proposals", payload).then((r) => r.data);
export const downloadSurveyCsv = () => http.get("/admin/survey/export", { responseType: "blob" }).then((r) => r.data);
